module.exports = __webpack_public_path__ + "static/media/viva_wallet_logo.01d2d269.svg";